import type { ButtonHTMLAttributes, ReactNode } from 'react';
import type { LucideIcon } from 'lucide-react';
import { Loader2 } from 'lucide-react';

type Variant = 'primary' | 'outline' | 'ghost' | 'danger';

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: Variant;
  icon?: LucideIcon;
  small?: boolean;
  loading?: boolean;
  children?: ReactNode;
}

export function Button({
  variant = 'outline',
  icon: Icon,
  small,
  loading,
  children,
  className,
  disabled,
  type = 'button',
  ...rest
}: ButtonProps) {
  const size = small ? 13 : 15;
  return (
    <button
      type={type}
      className={[
        'btn',
        `btn--${variant}`,
        small ? 'btn--small' : '',
        // Só ícone, sem texto: vira quadrado. Decidido aqui, e não por `:has()`
        // no CSS, porque texto solto não é elemento — o seletor não o enxerga
        // e espremia "+ Nova unidade" num quadrado de 32px.
        Icon && (children === undefined || children === null || children === false) ? 'btn--icon' : '',
        className ?? '',
      ]
        .filter(Boolean)
        .join(' ')}
      disabled={disabled || loading}
      {...rest}
    >
      {loading ? (
        <Loader2 size={size} strokeWidth={2.2} className="spin" aria-hidden />
      ) : (
        Icon && <Icon size={size} strokeWidth={2.2} aria-hidden />
      )}
      {children}
    </button>
  );
}
